module.exports = __webpack_public_path__ + "static/img/invite_icon.b9131bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite_icon.jpg
// module id = 68cn
// module chunks = 0